import React from "react";
import "./payment.css";
const Terms = () => {
  return (
    <>
      <div className="term-title">Terms and Conditions</div>
      <div className="term-list">
        <ul>
          <li>
            1. I hereby declare that all the details provided are true and
            correct.
          </li>
          <li>
            2. I confirm that my vehicle possesses a valid PUC Certificate.
          </li>
          <li>
            3. I consent that my modifications made to the details after payment
            may necessitate additional charges.
          </li>
          <li>
            4. Vibe Insurance Broking and Advisory Services Pvt Ltd, including
            its representatives, shall not be held resposible for any changes
            due to the incorrect information provided.
          </li>
          <li>
            5. The insurer reserves the right to deny a claim if the information
            provided by me regarding previous claims and No Claim Bonus(NCB) in
            the previous policy is incorrect.
          </li>
          <li>
            6. Please select additional covers for Compulsory personal accident
            cover which is mandotory if you don't have an existing Compulsory
            personal accident cover of 15 Lakhs.
          </li>
          <li>
            7. I consent and confirm that any inconsistencies found in the
            information provided by me may result in the non-issuance of the
            policy, cancellation of an already issued policy, and/or rejection
            of a claim.
          </li>
          <li>
            8. I hereby confirm, if i have selected Compulsory personal accident
            as a cover, then I hold another personal accident cover amounting to
            Rs 15,00,000/- or more or I do not possess a valid driving license.
          </li>
        </ul>
      </div>
    </>
  );
};

export default Terms;
